import type { CaseDetail } from '@/types/domain'

import { CargoCard } from './CargoCard'
import { ContainersCard } from './ContainersCard'
import { TermsCard, TimingCard } from './DetailsCard'
import { ProfitCard } from './ProfitCard'
import { RouteCard } from './RouteCard'

/* The overview is FR-24 read back as an EVEN GRID of summary cards (S-11
 * revision, owner review of 2026-10-16): the route, the cargo, the boxes, the
 * terms, the dates and who answers for them, and — for a reader the money
 * block was served to — the profit. One question per card, so the founder's
 * first glance and the operator's daily check read the same surface.
 *
 * Three per row at `lg`, two at `md`, one below. A grid row stretches its
 * cards to one height (the default `align-items: stretch`), which is the whole
 * fix for the uneven overview: the old layout put the cargo and the containers
 * side by side with `items-start`, and a full-width details card under them.
 * Every card is always mounted, saying so when it has nothing, so the grid's
 * rows never shift because one fact is missing. No legs here: they have their
 * own tab, «Плечи». */

export function OverviewSection({ record }: { record: CaseDetail }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <RouteCard record={record} />
      <CargoCard cargo={record.cargo} description={record.cargoDescription} figures={record} />
      <ContainersCard containers={record.containers} legs={record.legs} />
      <TermsCard record={record} />
      <TimingCard record={record} />
      {record.money ? <ProfitCard money={record.money} /> : null}
    </div>
  )
}
